import axios from 'axios'
import React, { useContext, useEffect, useState } from 'react'
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import moment from 'moment';

import authContext from '../context/authContext/authContext';
import AddProduct from '../components/modals/AddProduct';
import EditProduct from '../components/modals/EditProduct';
import { useDispatch, useSelector } from 'react-redux';
import { deleteProductAction, getProductsAction } from '../redux/actions/productsAction';
import Loader from '../utils/Loader';

const Products = () => {
  const dispatch = useDispatch();
  const { getConfig } = useContext(authContext)
  const config = getConfig();
  const intialState = { products: [] }

  const [expandedRow, setExpandedRow] = useState(null);
  const [state, setCompleteState] = useState(intialState)
  const [expandedProducts, setExpandedProducts] = useState([]);
  const setState = (newState) => setCompleteState((prevState) => ({ ...prevState, ...newState }))

  const { loading, products } = useSelector((state) => state.products)

  const deleteProduct = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
      showCancelButton: true,
      reverseButtons: true // 👈 this does the trick
    }).then((result) => {
      if (result.isConfirmed) {
        confirmDeleteProduct(id);
      }
    });
  }

  const confirmDeleteProduct = async (id) => {
    const data = { id }
    dispatch(deleteProductAction(data, config, getProducts))
  }

  const getProducts = async () => {
    dispatch(getProductsAction(config))
  }

  useEffect(() => {
    getProducts();
  }, []);

  return (
    <div className='main-container pb-1'>
      <div className="card-box mb-30">
        <div className='table-card-header'>
          <div className='d-flex align-items-center'>
            <h2 className="h4 mb-0 py-2">GleamDesk Products</h2>
            <div className='ml-3'>
              <Loader isLoading={loading} />
            </div>
          </div>
          <div>
            <button className='btn gleamdesk-blue' onClick={() => setState({ openAddProductModal: true })} disabled={loading}>
              <i className='fa fa-plus mr-1' />
              <span>Add Product</span>
            </button>
          </div>
        </div>
        <div className="overflow-x-scroll">
          <table className="table table-hover">
            <thead>
              <tr>
                <th scope="col">Title</th>
                <th scope="col">Slogan</th>
                <th scope="col">Description</th>
                <th scope="col">Tokens</th>
                <th scope="col">Time</th>
                <th scope="col">Actions</th>
              </tr>
            </thead>
            <tbody>
              {(products || []).map((product) => {
                const {
                  _id,
                  title,
                  slogan,
                  description,
                  tokens,
                  createdAt,
                  subProducts = []
                } = product;

                const isExpandedRow = expandedRow === _id;
                return (
                  <React.Fragment key={_id}>
                    <tr>
                      <td><strong>{title}</strong></td>
                      <td>{slogan}</td>
                      <td>{description}</td>
                      <td>{tokens}</td>
                      <td>
                        <div>{moment(createdAt).format("dddd, MMMM Do YYYY")}</div>
                        <div className='text-muted fs-12'>{moment(createdAt).format("h:mm a")}</div>
                      </td>

                      <td className='actions-container'>
                        {/* EDIT PRODUCT */}
                        <button
                          className='btn btn-secondary btn-sm my-1 mx-1'
                          title="Edit Product"
                          onClick={() => setState({ openEditProductModal: true, parentId: _id })}
                        >
                          <i className='fa fa-pencil' />
                        </button>

                        {/* DELETE PRODUCT */}
                        <button
                          className='btn btn-danger btn-sm my-1 mx-1'
                          title="Delete Product"
                          onClick={() => deleteProduct(_id)}
                        >
                          <i className='fa fa-trash' />
                        </button>

                        {/* ADD SUBPRODUCT */}
                        <button
                          className='btn btn-info btn-sm my-1 mx-1'
                          title="Add Subproduct"
                          onClick={() => setState({ openAddProductModal: true, parentId: _id })}
                        >
                          <i className='fa fa-plus' />
                        </button>

                        {/* EXPAND / COLLAPSE */}
                        <button
                          className='btn btn-light btn-sm my-1 mx-1'
                          title={isExpandedRow ? "Collapse" : "Expand"}
                          onClick={() => setExpandedRow(isExpandedRow ? null : _id)}
                        >
                          <i className={`fa fa-level-${isExpandedRow ? "up" : "down"}`} />
                        </button>
                      </td>
                    </tr>

                    {/* SUBPRODUCT ROW */}
                    {expandedRow === _id && (
                      <tr className="bg-light">
                        <td colSpan="6">
                          <div className="nested-subproduct-container">
                            <div className="font-weight-bold mb-2">
                              <span>{title}</span>
                              <span className='text-muted ml-2'>(Subproducts)</span>
                            </div>
                            {subProducts.length === 0 ? (
                              <div className="text-muted p-2">No subproducts added yet.</div>
                            ) : (
                              <table className="table table-sm table-bordered">
                                <thead>
                                  <tr>
                                    <th scope="col">Sub Title</th>
                                    <th scope="col">Slogan</th>
                                    <th scope="col">Description</th>
                                    <th scope="col">Tokens</th>
                                    <th scope="col">Time</th>
                                    <th scope="col">Actions</th>
                                  </tr>
                                </thead>

                                <tbody>
                                  {subProducts.map((sub) => (
                                    <tr key={sub._id}>
                                      <td>{sub.title}</td>
                                      <td>{sub.slogan}</td>
                                      <td>{sub.description}</td>
                                      <td>{sub.tokens}</td>
                                      <td>
                                        <div>{moment(createdAt).format("dddd, MMMM Do YYYY")}</div>
                                        <div className='text-muted fs-12'>{moment(createdAt).format("h:mm a")}</div>
                                      </td>
                                      <td className='actions-container'>
                                        <button
                                          className="btn btn-secondary btn-sm mx-1"
                                          title="Edit Subproduct"
                                          onClick={() => setState({
                                            openEditProductModal: true,
                                            parentId: _id,
                                            subProductId: sub._id
                                          })}
                                        >
                                          <i className="fa fa-pencil" />
                                        </button>

                                        <button
                                          className="btn btn-danger btn-sm mx-1"
                                          title="Delete Subproduct"
                                          onClick={() => deleteProduct(sub._id)}
                                        >
                                          <i className="fa fa-trash" />
                                        </button>
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            )}
                          </div>
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                );
              })}

            </tbody>
          </table>
        </div>
      </div>

      <AddProduct
        key={() => new Date()}
        isOpen={state?.openAddProductModal}
        parentId={state?.parentId}
        toggle={() => setState({ openAddProductModal: false, parentId: '' })}
        getProducts={getProducts}
        loading={loading}
      />

      <EditProduct
        key={() => new Date()}
        isOpen={state.openEditProductModal}
        toggle={() => setState({ openEditProductModal: false, parentId: null, subProductId: null})}
        parentId={state.parentId}
        subProductId={state.subProductId}
        products={products || []}
        getProducts={getProducts}
        loading={loading}
      />
    </div >
  )
}

export default Products